import { matchesUpdates } from '../../../build/featureCollections/features';

/**
 * Aktualizace fáze ligy
 *
 * @param {HTMLElement} wrapper HTML element obsahující seznam zápasů ligové fáze, která se má aktualizovat.
 * @return {void}
 */
export const initLeaguePhaseReloader = (wrapper: HTMLElement): void => {
  if (!wrapper) {
    return;
  }

  const boxId = wrapper.getAttribute('data-matches-phase-reloader');
  const seasonId = wrapper.getAttribute('data-season');
  const matchList: HTMLElement | null = wrapper.querySelector(`[data-phase-matches="${boxId}"]`);

  if (!matchList) {
    console.warn(`Element [data-phase-matches="${boxId}"] nebyl nalezen.`);
    return;
  }

  /**
   * zobrazování a skrývání rozbalovacího seznamu
   */
  const dropdownToggleBtn: HTMLButtonElement | null = wrapper.querySelector(
    '[data-match-overview-phase-dropdown-toogle]'
  );
  const dropdownLoader: HTMLSpanElement | null =
    dropdownToggleBtn && dropdownToggleBtn.querySelector('[data-match-overview-phase-loader]');
  const dropdownList: HTMLUListElement | null = wrapper.querySelector(
    '[data-match-overview-phase-dropdown-toogle-list]'
  );

  if (dropdownToggleBtn && dropdownList) {
    dropdownToggleBtn.addEventListener('click', function () {
      dropdownList.classList.toggle('match-overview-phase-dropdown__list--active');
    });
  }

  const buttons: NodeListOf<HTMLButtonElement> = wrapper.querySelectorAll('[data-phase]');
  const actualPhaseName = wrapper.querySelector('[data-actual-phase]');

  /**
   * Kliknutí na button - fáze v dropdownu
   */
  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const phaseId = button.getAttribute('data-phase');
      const phaseName = button.textContent;

      // Odstranění třídy 'active' ze všech 'list-item'
      wrapper.querySelectorAll('[data-match-overview-phase-dropdown-list-item]').forEach((li) => {
        li.classList.remove('match-overview-phase-dropdown__list-item--active');
      });

      // Přidání třídy 'active' na parent 'list-item'
      const parentLi = button.closest('.match-overview-phase-dropdown__list-item');
      if (parentLi) {
        parentLi.classList.add('match-overview-phase-dropdown__list-item--active');
      }

      // Nastavit aktivní třídu pouze na aktuální tlačítko
      buttons.forEach((btn) =>
        btn.classList.toggle(
          'match-overview-phase-dropdown__list-item-button--active',
          btn === button
        )
      );

      if (phaseId && phaseName) {
        phaseReload(phaseId, phaseName);
      }

      if (dropdownList) {
        dropdownList.classList.toggle('match-overview-phase-dropdown__list--active');
      }
    });
  });

  /**
   * Načte aktualizovaná data pro zadanou fázi ligy a aktualizuje její název.
   * @param {string} phaseId – ID fáze k načtení.
   * @param {string} phaseName – Název fáze po načtení.
   */
  const phaseReload = (phaseId: string, phaseName: string) => {
    const url = `?_sobfr=${boxId}&phase=${phaseId}&season=${seasonId}&action=phase&ajax`;

    if (dropdownLoader) {
      dropdownLoader.style.display = 'inline-flex';
    }

    if (matchList && actualPhaseName) {
      fetch(url, {
        method: 'GET',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Chyba při načítání dat');
          }
          return response.text();
        })
        .then(async (data) => {
          matchList.innerHTML = data;
          matchList.style.opacity = '1';

          // Akutalizace názvu fáze
          actualPhaseName.innerHTML = phaseName;

          // Nastavi se pro donačtené zápasy update přes web sokety.
          await matchesUpdates();
        })
        .catch(() => {
          matchList.innerHTML = '<p>Data se nepodařilo načíst</p>';
          matchList.style.opacity = '1';
        })
        .finally(() => {
          // Skrytí preloaderu
          if (dropdownLoader) {
            dropdownLoader.style.display = 'none';
          }
        });
    }
  };
};
